export const LinkElement = (props: { url: string[]; articleId: string; linkIndex: number }) => {
  const { url, articleId, linkIndex } = props;
  const href = `/api/v1/data/doc/${articleId}/redirect?linkIndex=${linkIndex}`;
  return (
    <span>
      {url[0] + " "}
      <a href={href} target="_blank" rel="noreferrer nofollow" >
        {url[1]}
      </a>
      {url[2] ? " (" + url[2] + ")" : ""}
    </span>
  );
};
